export const StatusColor: { [x: string]: string } = {
  passed: '#8CC63F',
  untested: '#00A99D',
  blocked: '#92278F',
  retest: '#2E3192',
  failed: '#ED1C24',
  not_applicable: '#964B00',
  in_progress: '#F7931E',
  hold: '#CCCCCC',
};

export const StatusLabels: { [x: string]: string } = {
  passed: 'Passed',
  untested: 'Untested',
  blocked: 'Blocked',
  retest: 'Retest',
  failed: 'Failed',
  not_applicable: 'Not Applicable',
  in_progress: 'In Progress',
  hold: 'Hold',
};
